import { render, staticRenderFns } from "./Gallery.html?vue&type=template&id=39bc83be&"
import script from "./Gallery.js?vue&type=script&lang=js&"
export * from "./Gallery.js?vue&type=script&lang=js&"
import style0 from "./Gallery.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports